<template>
  <div class="certification">
    <div class="certification-title">
      <h3>国际职业技能委员会</h3>
      <h1>{{ data.certName }}认证电子证书</h1>
      <p class="certification-number">证书编号：{{ data.certSeriesNo }}</p>
    </div>

    <div class="certification-body">
      <p class="certification-body-paragraph">
        <span>{{ data.realName }}（身份证号：{{ data.idCardSeriesNo }}）</span>
        已通过国际职业技能委员会组织的国际{{ data.examName }}水平考试，成绩合格，达到{{ level }}{{ data.certName }}标准，特发此证。
      </p>

      <p class="certification-body-paragraph">
        <span class="certification-body-title">持证人：</span>{{ data.realName }}
      </p>
      <p class="certification-body-paragraph">
        <span class="certification-body-title">性别：</span>{{ data.sex | formatSex }}
      </p>
      <p class="certification-body-paragraph">
        <span class="certification-body-title">身份证号：</span>{{ data.idCardSeriesNo }}
      </p>
      <p class="certification-body-paragraph">
        <span class="certification-body-title">认证资质：</span>{{ data.certName }}
      </p>
      <p class="certification-body-paragraph">
        <span class="certification-body-title">证书编号：</span>{{ data.certSeriesNo }}
      </p>
    </div>

    <div class="certification-footer">
      <p class="text-bold">国际职业技能委员会</p>
      <p class="text-bold">International Professional Skills Commission</p>
      <p class="text-bold">{{ data.createAt | formatDate('yyyy.MM.dd') }}</p>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    level () {
      const { score } = this.data
      if (score >= 90) return 'Yesassess2级'
      if (score >= 80) return 'Yesassess3级'
      if (score >= 70) return 'Yesassess4级'
      return ''
    }
  }
}
</script>


<style lang="less" scoped>
.certification {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 600px;
  height: 800px;
  padding: 40px;
  font-size: 14px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  &-title {
    margin-bottom: 10px;
    padding-bottom: 10px;
    line-height: 2;
    text-align: center;
  }
  &-number {
    margin-top: 10px;
    padding-top: 5px;
    border-top: 2px solid #e0a970;
    font-weight: bold;
    text-align: right;
  }
  &-body {
    margin: 40px;

    p {
      margin-bottom: 1em;

      span {
        font-weight: bold;
      }
    }
    &-paragraph {
      text-indent: 2em;
      line-height: 2;
    }
    &-title {
      display: inline-block;
      width: 8em;
    }
  }
  &-footer {
    text-align: right;
  }
}
</style>
